import { TableRow, TableCell, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface EmptyTableRowProps {
  colSpan: number;
}

export function EmptyTableRow({ colSpan }: EmptyTableRowProps) {
  const { t } = useTranslation();
  return (
    <TableRow>
      <TableCell colSpan={colSpan} align="center" sx={{ py: 4 }}>
        <Typography
          sx={{
            color: "text.secondary",
          }}
        >
          {t("common.noData")}
        </Typography>
      </TableCell>
    </TableRow>
  );
}
